// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAe15e-UC89N7mGsaUqkRmxNwOKhNcqT0",
  authDomain: "sreasy-6fc5b.firebaseapp.com",
  projectId: "sreasy-6fc5b",
  storageBucket: "sreasy-6fc5b.appspot.com",
  messagingSenderId: "123813357403",
  appId: "1:123813357403:web:cd1e6bc1ff64ea25bf1c7e",
  measurementId: "G-GVSXD1F0EW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


const useFirebase = () => {
  return {
    analytics,
    logEvent,
  }
}

export { useFirebase };
